import React, { Component } from 'react';
import './RecordingsTable.css';
import { connect } from 'react-redux';
import XLSX from 'xlsx';
import ReactTable from 'react-table';
import { actions } from '../../../Reducks/Recordings/index';
import { CHECKBOX, VALUE_ADD } from '../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import {
  trackAnalyticsFeature,
  trackAnalyticsGenerateReportFeature
} from '../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { XLS } from '../../../Utils/Constants';
import { HeaderSortComponent } from '../../../Scss/Custom/ReactTable/HeaderSortComponent';
import {
  dateSorter,
  dayDateFormatterWithTimezone,
  getRecordingsData,
  percentageFormatter,
  timeFormatterInHrMinSec
} from '../../../Utils/TableUtil';
import { denormalizeRecordings } from '../../../Reducks/Recordings/RecordingsUtils';
import { sessionsTableSkeletonScreen } from '../../../SkeletonScreens/SkeletonScreen';
import PropTypes from 'prop-types';
import SimpleSearchBox from '../../../Components/SearchBox/SimpleSearchBox';

import { RecordingSource, RecordingsTableVisibleColumns } from '../../../Utils/Constants';
import { toggleElement } from '../../../Utils/ArrayUtils';
import { getRecordingsTableColumnOptions } from '../../../Components/CheckedMenu/CheckedMenuItemsHelper';
import CheckedMenu from '../../../Components/CheckedMenu/CheckedMenu';
import { NavLink } from 'react-router-dom';
import Menu from '../../../Components/Menu/Menu';
import DownloadIcon from '../../../Components/Buttons/DownloadIcon';
import { getReportTypeMenuItems } from '../../../Components/Menu/MenuItemsHelper';
import { getUnion } from '../../../Utils/ArrayUtils';

export class RecordingsTable extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    uniqueId: PropTypes.string.isRequired,
    focusedRecordingKeyInTable: PropTypes.string,
    focusRecordingInChart: PropTypes.func,
    reportSource: PropTypes.array,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    recordings: PropTypes.object,
    filterRecordings: PropTypes.func,
    toggleRecording: PropTypes.func,
    toggleAllRecordings: PropTypes.func,
    recordingsData: PropTypes.object
  };
  constructor(props) {
    super(props);
    this.state = {
      visibleColumns: [
        RecordingsTableVisibleColumns.SOURCE,
        RecordingsTableVisibleColumns.AVG_VIEW_DURATION,
        RecordingsTableVisibleColumns.LENGTH,
        RecordingsTableVisibleColumns.SHARES,
        RecordingsTableVisibleColumns.VIEWS,
        RecordingsTableVisibleColumns.PUBLISHED_DATE
      ]
    };
    this._RecordingNameRefs = new Map();
  }

  onClickHandler = updateId => {
    this.setState(prevState => ({
      visibleColumns: toggleElement(updateId, prevState.visibleColumns)
    }));
  };

  componentDidUpdate(prevProps) {
    this.scrollToRecordingInTable(
      prevProps ? prevProps.focusedRecordingKeyInTable : null,
      this.props.focusedRecordingKeyInTable
    );
    if (this.props.modalFlag !== prevProps.modalFlag) {
      const tableId = this.props.modalFlag ? 'recordingsTableInReports' : 'recordingTableInOverview';
      this.props.passRecordingsTableId(tableId);
    }
  }

  componentDidMount() {
    if (this.props && this.props.passRecordingsTableId) {
      const tableId = this.props.modalFlag ? 'recordingsTableInReports' : 'recordingTableInOverview';
      this.props.passRecordingsTableId(tableId);
    }
  }

  getHeaders = () => {
    const { t } = this.context;
    const columns = this.getRecordingColumns();
    const header = [];
    columns.forEach(({ show, accessor }) => {
      if (show || accessor === RecordingTableAccessor.NAME) {
        switch (accessor) {
          case RecordingTableAccessor.NAME:
            header.push([t('tableHeaderColumns.name'), accessor]);
            break;
          case RecordingTableAccessor.DATE_UPLOADED:
            header.push([t('tableHeaderColumns.publishedDate'), accessor]);
            break;
          case RecordingTableAccessor.VIEW_COUNT:
            header.push([t('tableHeaderColumns.views'), accessor]);
            break;
          case RecordingTableAccessor.SHARE_COUNT:
            header.push([t('tableHeaderColumns.shares'), accessor]);
            break;
          case RecordingTableAccessor.LENGTH:
            header.push([t('tableHeaderColumns.length'), accessor]);
            break;
          case RecordingTableAccessor.AVG_WATCH_TIME:
            header.push([t('recordingDetails.avgPercentageViewed'), accessor]);
            break;
          case RecordingTableAccessor.SOURCE:
            header.push([t('tableHeaderColumns.source'), accessor]);
            break;
          default:
            console.error('unexpected case');
            break;
        }
      }
    });
    return header;
  };

  getRecords = (recordingsData, headers) => {
    const data = [];
    const { filteredKeys } = this.props.recordingsData;
    recordingsData.forEach(recording => {
      let row = [];
      if (filteredKeys.includes(recording.recordingKey)) {
        headers.forEach(element => {
          switch (element) {
            case RecordingTableAccessor.DATE_UPLOADED:
              row.push(dayDateFormatterWithTimezone(recording[element].dateTime, recording[element].timeZone));
              break;
            case RecordingTableAccessor.LENGTH:
              row.push(timeFormatterInHrMinSec({ value: recording[element] }));
              break;
            case RecordingTableAccessor.AVG_WATCH_TIME:
              row.push(percentageFormatter({ value: recording[element] }));
              break;
            default:
              row.push(recording[element]);
          }
        });
        data.push(row);
      }
    });
    return data;
  };

  exportFile = (recordingsData, id) => {
    const { t } = this.context;
    const fileName = t('recordings.recordingsReportName');
    const headers = this.getHeaders();
    const records = this.getRecords(recordingsData, headers.map(item => item[1]));
    const data = getUnion([headers.map(item => item[0])], records);
    const workBook = XLSX.utils.book_new();
    const dataSheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workBook, dataSheet);
    XLSX.writeFile(workBook, `${fileName}.${id === XLS ? 'xlsx' : 'csv'}`);
  };

  render() {
    const { fetching, filtering } = this.props.recordings;
    const recordings = this.props.recordingsData;
    const focusRecordingInChart = this.props.focusRecordingInChart;
    const reportSource = this.props.reportSource;
    const filteredRecordings = denormalizeRecordings(recordings.filteredKeys, recordings.byKey);
    const detailsMenu = getRecordingsTableColumnOptions().map(item => {
      return {
        onClick: () => this.onClickHandler(item.id),
        text: item.title,
        id: `recordingsTable_manage_${item.id}`,
        checked: this.state.visibleColumns.includes(item.id)
      };
    });
    return (
      <div className="recordingsTableSection">
        {this.getSearchBar(detailsMenu, filteredRecordings, reportSource)}
        {fetching || filtering
          ? sessionsTableSkeletonScreen()
          : this.getRecordingsTable(filteredRecordings, focusRecordingInChart, reportSource)}
      </div>
    );
  }

  getRecordingsTable = (filteredRecordings, focusRecordingInChart, reportSource) => {
    return (
      <ReactTable
        keyField="recordingKey"
        data={getRecordingsData(filteredRecordings, reportSource)}
        columns={this.getRecordingColumns()}
        defaultPageSize={filteredRecordings.length}
        minRows={5}
        style={{ height: '270px' }}
        showPagination={false}
        className="-highlight"
        defaultSorted={[{ id: 'dateUploaded', desc: true }]}
        getTrProps={(state, rowInfo) => {
          return {
            onMouseEnter: () => focusRecordingInChart(rowInfo.original.recordingKey),
            onMouseLeave: () => focusRecordingInChart(null)
          };
        }}
      />
    );
  };

  getSearchBar = (detailsMenu, filteredRecordings, reportSource) => {
    const { mixpanelData, uniqueId } = this.props;
    const { t } = this.context;
    const { isBig } = this.props;
    const detailsDownloadMenu = [];
    const menuDownloadItems = getReportTypeMenuItems();
    const recordingsData = getRecordingsData(filteredRecordings, reportSource);
    menuDownloadItems.map(item =>
      detailsDownloadMenu.push({
        onClick: () => this.exportFile(recordingsData, item.id),
        text: item.title,
        iconClassName: item.iconClass,
        id: item.id
      })
    );
    return (
      <div className="searchBoxContainer">
        <SimpleSearchBox
          searchString={this.props.recordings.filter.searchString}
          placeHolder={t('recordings.search')}
          onSearchInputChange={this.handleSearch}
          mixpanelData={mixpanelData}
        />
        <div className="d-flex justify-content-between align-items-center">
          <CheckedMenu
            menuKey={`manageColumns_${uniqueId}`}
            detailsMenu={detailsMenu}
            buttonName={t('sessionDetails.manageColumns')}
            isBig={isBig}
          />
          <Menu
            isBig={isBig}
            menuKey={`download_${uniqueId}`}
            buttonName={t('buttons.downloadCamelCase')}
            detailsMenu={detailsDownloadMenu}
            buttonComponent={<DownloadIcon isBig={isBig} />}
          />
        </div>
      </div>
    );
  };

  handleSearch = value => {
    if (value !== null) {
      this.props.filterRecordings({ searchString: value });
    }
  };

  getRecordingColumns = () => {
    const { t } = this.context;
    const { filteredSelectedRecordingKeys, filteredKeys } = this.props.recordingsData;

    return [
      {
        accessor: '',
        Header: this.checkBoxHeaderFormatter(filteredKeys.length, filteredSelectedRecordingKeys.length),
        Cell: this.checkBoxCellFormatter,
        sortable: false,
        width: 67,
        resizable: false,
        style: { textAlign: 'center', paddingLeft: '12px' },
        headerStyle: { textAlign: 'center', paddingLeft: '12px' }
      },
      {
        accessor: RecordingTableAccessor.NAME,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.name')} />,
        Cell: this.recordingNameFormatter,
        minWidth: 200
      },
      {
        accessor: RecordingTableAccessor.DATE_UPLOADED,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.publishedDate')} />,
        Cell: cell => dayDateFormatterWithTimezone(cell.value.dateTime, cell.value.timeZone),
        show: this.state.visibleColumns.includes(RecordingsTableVisibleColumns.PUBLISHED_DATE),
        sortMethod: dateSorter
      },
      {
        accessor: RecordingTableAccessor.VIEW_COUNT,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.views')} />,
        show: this.state.visibleColumns.includes(RecordingsTableVisibleColumns.VIEWS)
      },
      {
        accessor: RecordingTableAccessor.SHARE_COUNT,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.shares')} />,
        show: this.state.visibleColumns.includes(RecordingsTableVisibleColumns.SHARES)
      },
      {
        accessor: RecordingTableAccessor.LENGTH,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.length')} />,
        show: this.state.visibleColumns.includes(RecordingsTableVisibleColumns.LENGTH),
        Cell: timeFormatterInHrMinSec
      },
      {
        accessor: RecordingTableAccessor.AVG_WATCH_TIME,
        Header: <HeaderSortComponent headerTitle={t('recordingDetails.avgPercentageViewed')} />,
        show: this.state.visibleColumns.includes(RecordingsTableVisibleColumns.AVG_VIEW_DURATION),
        Cell: percentageFormatter
      },
      {
        accessor: RecordingTableAccessor.SOURCE,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.source')} />,
        show: this.state.visibleColumns.includes(RecordingsTableVisibleColumns.SOURCE)
      }
    ];
  };

  checkBoxHeaderFormatter = (totalCount, selectedCount) => {
    const checked = selectedCount !== 0;
    const isIntermediate = selectedCount !== 0 && selectedCount !== totalCount;

    const onCheck = e => {
      trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
      if (this.props.mixpanelData.reportType) {
        trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
      }
      this.props.toggleAllRecordings(e.target.checked);
    };
    const intermediate = input => {
      if (input) {
        input.indeterminate = isIntermediate;
      }
    };
    return <input type="checkbox" ref={intermediate} checked={checked} onChange={onCheck} />;
  };

  recordingNameFormatter = ({ original }) => {
    let recordingKey,
      recordingSource = null;

    if (original.recordingKey.endsWith('-g2s')) {
      recordingKey = original.recordingKey.replace('-g2s', '');
      recordingSource = RecordingSource.G2S;
    } else if (original.recordingKey.endsWith('-g2s-embedded')) {
      recordingKey = original.recordingKey.replace('-g2s-embedded', '');
      recordingSource = RecordingSource.G2S_EMBEDDED;
    } else {
      recordingKey = original.recordingKey;
      recordingSource = RecordingSource.G2W;
    }
    return <NavLink to={`/analytics/recordings/${recordingSource}/${recordingKey}`}>{original.name}</NavLink>;
  };

  checkBoxCellFormatter = ({ original }) => {
    return (
      <input
        type="checkbox"
        ref={c => this._RecordingNameRefs.set(original.recordingKey, c)}
        checked={this.props.recordingsData.filteredSelectedRecordingKeys.includes(original.recordingKey)}
        onChange={e => {
          trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
          if (this.props.mixpanelData.reportType) {
            trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
          }
          this.props.toggleRecording(original.recordingKey, e.target.checked);
        }}
      />
    );
  };
  scrollToRecordingInTable = (previousRecordingKey, newRecordingKey) => {
    if (newRecordingKey) {
      const node = this._RecordingNameRefs.get(newRecordingKey);
      try {
        const row = node.parentElement.parentElement.parentElement;
        const tableBodyNode = row.parentElement;
        tableBodyNode.scrollTop = row.offsetTop - 45;
        const { scrollX, scrollY } = window;
        node.focus({ preventScroll: true });
        window.scrollTo(scrollX, scrollY);

        return this;
      } catch (e) {}
    } else if (previousRecordingKey) {
      const node = this._RecordingNameRefs.get(previousRecordingKey);
      if (node) {
        node.blur();
      }
    }
  };
}

export default connect(
  state => ({
    recordings: state.reduced_recordings,
    modalFlag: state.reduced_reports.isGenerateReportOpen
  }),
  {
    filterRecordings: actions.filterRecordingsByCount,
    toggleRecording: actions.toggleRecording,
    toggleAllRecordings: actions.toggleAllRecordings,
    passRecordingsTableId: actions.postRecordingsTableId
  }
)(RecordingsTable);

class RecordingTableAccessor {
  static get NAME() {
    return 'name';
  }
  static get DATE_UPLOADED() {
    return 'dateUploaded';
  }
  static get VIEW_COUNT() {
    return 'viewCount';
  }
  static get SHARE_COUNT() {
    return 'shareCount';
  }
  static get LENGTH() {
    return 'length';
  }
  static get AVG_WATCH_TIME() {
    return 'avgWatchTime';
  }
  static get SOURCE() {
    return 'source';
  }
}



// WEBPACK FOOTER //
// ./src/GoToWebinar/Recordings/Table/RecordingsTable.js